import { useState } from 'react'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'
import Tabs from '../../ui-components/Tabs'
import RollingReturnsPerformanceSection from './RRPerformance'
import PeersSection from '../../peers/PeersSection'
import RankSection from '../../rank/RankSection'

enum RRTabs {
  PERFORMANCE = 'Returns',
  RANK = 'Rank Trend',
  PEERS = 'Leaderboard'
}

export default function RollingReturnsBody() {
  const [selectedTabId, setSelectedTabId] = useState<`${RRTabs}`>(RRTabs.PERFORMANCE)
  const { data: metadata } = useMetaDataContext()

  return (
    <div className='flex flex-col w-full pt-[11px]'>
      <div className='pb-[24px] w-full'>
        <div className='h-11'>
          <Tabs
            selectedTabId={selectedTabId}
            tabsData={[
              { id: RRTabs.PERFORMANCE, label: RRTabs.PERFORMANCE },
              { id: RRTabs.RANK, label: RRTabs.RANK },
              { id: RRTabs.PEERS, label: RRTabs.PEERS }
            ]}
            onTabClick={(id) => setSelectedTabId(() => id as `${RRTabs}`)}
            isFullWidth
            tabsClassName='h-[40px]'
          />
        </div>
      </div>
      {{
        [RRTabs.PERFORMANCE]: <RollingReturnsPerformanceSection />,
        [RRTabs.RANK]: <RankSection ranksType='ROLLING' />,
        [RRTabs.PEERS]: <PeersSection peersType='ROLLING' fundCategory={metadata?.fundDetails?.category ?? ''} />
      }[selectedTabId] || <div className='h-[400px] w-full' />}
    </div>
  )
}
